<div class="receipt-card">
    <div class="receipt-card-accent" [ngClass]="'accent-' + data.receiptStatusColor"></div>
    <div class="receipt-card-inner">

        <div class="receipt-col receipt-col-icon">
            <app-icon-type [icon]="data.branchType" color="{{ data.receiptStatusColor }}"></app-icon-type>
            <span class="receipt-status-label">Estado</span>
            <span class="receipt-status-value">{{ data.receiptStatus }}</span>
            <span class="docCobro" *ngIf="data.docCobroNumber">Documento de Cobro</span>
        </div>

        <div class="receipt-separator"></div>

        <div class="receipt-col receipt-col-policy">
            <div class="receipt-field" *ngIf="policyNumber">
                <span class="receipt-label">Nº de póliza / contrato:</span>
                <span class="receipt-value">{{ policyNumber }}</span>
            </div>
            <div class="receipt-field">
                <span class="receipt-label">Vigencia:</span>
                <span class="receipt-value">{{ data.receiptStartDate | date: 'dd/MM/yyyy' }} - {{ data.receiptEndDate | date: 'dd/MM/yyyy' }}</span>
            </div>
        </div>

        <div class="receipt-separator"></div>

        <div class="receipt-col receipt-col-receipt">
            <div class="receipt-field">
                <span class="receipt-label">Nº recibo:</span>
                <span class="receipt-value">{{ data.receiptNumber }}</span>
                <span class="receipt-extorno" *ngIf="'E' === data.receiptType && !data.docCobroNumber"> (Extorno)</span>
            </div>
            <div class="receipt-field" *ngIf="data.periodicidad">
                <span class="receipt-label">Periodicidad:</span>
                <span class="receipt-value">{{ data.periodicidad }}</span>
            </div>
        </div>

        <div class="receipt-separator"></div>

        <div class="receipt-col receipt-col-payment">
            <div class="receipt-field">
                <span class="receipt-label">Tipo de cobro:</span>
                <span class="receipt-value">{{ data.receiptPaymentMethod }}</span>
            </div>
        </div>

        <div class="receipt-separator"></div>

        <div class="receipt-col receipt-col-amount">
            <span class="receipt-amount-label">Importe</span>
            <span class="receipt-amount-value">{{ data.receiptAmount | currency:'EUR' }}</span>
        </div>

    </div>

    <div class="receipt-pay-button" *ngIf="canPay">
        <app-actions-dropdown label="PAGAR" [items]="payActions"></app-actions-dropdown>
    </div>
</div>
